
    import { useEffect } from "react";
    import { v4 as uuidv4 } from "uuid";

    function useDeviceId() {
    useEffect(() => {
        const existingId = localStorage.getItem("device_id");
        if (!existingId) {
        const newId = uuidv4();
        localStorage.setItem("device_id", newId);
        }
    }, []);
    }

    export default useDeviceId;
